import { useState, useEffect } from 'react';
import { getFacilityType } from '../constants/lov/facilities';
import { useSelector } from 'react-redux';

export const useFacilityType = (facilityCode) => {
  const [facilityName, setFacilityName] = useState('Loading...');
  const { country: userCountry } = useSelector((state) => state.user || {});
  const registerCountry = useSelector((state) => state.auth?.register?.country);
  const country = registerCountry || userCountry || 'MY';

  useEffect(() => {
    if (!facilityCode) {
      setFacilityName('Clinic');
      return;
    }

    const fetchFacilityType = async () => {
      try {
        const name = await getFacilityType(facilityCode, country);
        setFacilityName(name);
      } catch (error) {
        console.error('Error fetching facility type:', error);
        setFacilityName('Unknown');
      }
    };

    fetchFacilityType();
  }, [facilityCode, country]);

  return facilityName;
};